import React from 'react'
import generalStyles from '../../styles/general.module.css'
import getStringsBasedLang from '../../strings/get_strings'
import { Container, Grid } from '@material-ui/core'
import styles from './about_system.module.css'
import ShowAllButton from '../../modules/show_all_button'
import { useNavigate } from 'react-router-dom'

export default function AboutSystem() {
    let navigate = useNavigate()
    const lang = localStorage.getItem("lang")

    return (
        <Container>
            <div className={`${generalStyles.container} ${lang === 'en' ? 'englishIranSans' : ''}`}>
                <div className={styles.title_container}>
                    <img className={styles.wave_line_left} src={require('../../assets/img/wave_line1.svg').default} alt="Image" />
                    <img className={styles.wave_line_right} src={require('../../assets/img/wave_line1.svg').default} alt="Image" />
                    <span className={generalStyles.title}>{getStringsBasedLang("AboutSystem_Title")}</span>
                    <span className={generalStyles.subTitle}>{getStringsBasedLang("AboutSystem_subTitle")}</span>
                </div>
                <div className={styles.about_container}>
                    <Grid container spacing={2}>
                        <Grid item sm={12} md={6} lg={6}>
                            <img className={styles.about_img} src={require('../../assets/img/about_img.png')} alt="Image" />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <div className={styles.about_desParent}>
                                <div className={`${styles.des} ${lang === 'en' ? 'englishIranSans' : ''}`}>{getStringsBasedLang("aboutSystem_desContent1")}</div>
                                <div className={`${styles.des} ${lang === 'en' ? 'englishIranSans' : ''}`}>{getStringsBasedLang("aboutSystem_desContent2")}</div>
                                <div className={styles.showAll_container}><ShowAllButton doClick={() => navigate("/aboutApp")} /></div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </Container>
    )
}